import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';
import PageMetaHead from 'src/logic/config/meta/PageMetaHead';
import ContactHero from 'src/ui/components/smart/landing/contact/ContactHero';
import ContactSection from 'src/ui/components/smart/landing/contact/ContactSection';
import LandingLayout from 'src/ui/components/smart/landing/layout/LandingLayout';

const ContactPage = () => {
  return (
    <>
      <PageMetaHead
        page_meta={{
          title: 'Contact Us | Get in Touch with the eProcurement Team',
          description:
            'Have questions about our procurement platform? Contact eProcurement for support, partnership inquiries, or to request a product demo',
        }}
        useExactTitle
      />
      <div className='page'>
        <ContactHero />
        <ContactSection />
      </div>
    </>
  );
};

ContactPage.getLayout = function getLayout(page: React.ReactElement) {
  return <LandingLayout>{page}</LandingLayout>;
};

export default ContactPage;

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}
